import clsx from "clsx"

import styles from "./ContentEditable.module.css"

export { ContentEditable } from "./ContentEditable"

const baseContentEditableClass = clsx(
  styles.contentEditable,
  styles["em-normal"],
  styles["p-normal"],
)

export const contentEditableClass = clsx(
  baseContentEditableClass,
  styles["padding-normal"],
)

export const contentEditableClassWithIcon = clsx(
  contentEditableClass,
  styles["padding-normal"],
  styles["padding-icon"],
)

export const contentEditableNoPaddingClass = clsx(
  baseContentEditableClass,
  styles["padding-zero"],
)

export const tableFieldStyles = {
  tableWithControls: styles.tableWithControls,
  tableShrinkContainer: styles.tableShrinkContainer,
  addTableRowButton: styles.addTableRowButton,
  addTableColumnButton: styles.addTableColumnButton,
  tableHandle: styles.tableHandle,
  tableRowHandle: styles.tableRowHandle,
  tableColumnHandle: styles.tableColumnHandle,
  tableHandleVisible: styles.tableHandleVisible,
  tableSelectionOverlay: styles.tableSelectionOverlay,
}

export const contentEditablePlaceholderClass = styles.contentEditablePlaceholder
export const contentEditableMultilinePlaceholderClass =
  styles.contentEditableMultilinePlaceholder
